import type { EmbarcacaoVazaoBombasField } from "@/modules/embarcacoes";
import { formatDetailDate } from "../../../detail-format/detail-format";
import type { DetailFieldDefinition } from "../../../detail-format/detail-fields";

export const VAZAO_BOMBAS_ID = "vazao-bombas";
export const VAZAO_BOMBAS_TITLE = "Vazão das Bombas";
export const VAZAO_BOMBAS_TEST_ID = "embarcacao-vazao-bombas";
export const VAZAO_BOMBAS_LOADING_MESSAGE = "Carregando a Vazão das Bombas da embarcação...";

/** Padrão global de estado vazio do Hub para a seção sem informações. */
export const VAZAO_BOMBAS_EMPTY_STATE = {
  title: "Nenhuma informação de Vazão das Bombas disponível",
  description:
    "Assim que houver dados de vazão e pressão das bombas desta embarcação, eles aparecerão nesta seção.",
};

/** Os 17 campos, na ordem da HU: cada linha do grid pareia a vazão e a pressão do mesmo produto; a data de atualização da vazão fecha a lista (RN001). */
export const VAZAO_BOMBAS_FIELDS: DetailFieldDefinition<EmbarcacaoVazaoBombasField>[] = [
  { key: "vazaoCombustivel", label: "Vazão de Combustível (m³/h)" },
  { key: "pressaoCombustivel", label: "Pressão de Combustível (bar)" },
  { key: "vazaoAgua", label: "Vazão de Água (m³/h)" },
  { key: "pressaoAgua", label: "Pressão de Água (bar)" },
  { key: "vazaoOro", label: "Vazão ORO (m³/h)" },
  { key: "pressaoOro", label: "Pressão ORO (bar)" },
  { key: "vazaoAguaLastro", label: "Vazão de Água de Lastro (m³/h)" },
  { key: "pressaoAguaLastro", label: "Pressão de Água de Lastro (bar)" },
  { key: "vazaoOleoBase", label: "Vazão de Óleo de Base (m³/h)" },
  { key: "pressaoOleoBase", label: "Pressão de Óleo de Base (bar)" },
  { key: "vazaoSalmoura", label: "Vazão de Salmoura (m³/h)" },
  { key: "pressaoSalmoura", label: "Pressão de Salmoura (bar)" },
  { key: "vazaoLama", label: "Vazão de Lama (m³/h)" },
  { key: "pressaoLama", label: "Pressão de Lama (bar)" },
  { key: "vazaoGranel", label: "Vazão de Granel (m³/h)" },
  { key: "pressaoGranel", label: "Pressão de Granel (bar)" },
  {
    key: "atualizacaoVazaoBomba",
    label: "Data Atualização Vazão",
    format: formatDetailDate,
    startsRow: true,
  },
];
